const STORAGE_SESSION_ONLY = Object.freeze(['session']);
const STORAGE_LOCAL_AND_SESSION = Object.freeze(['local', 'session']);

const createDescriptor = (config) => Object.freeze(config);

export const merchantAddressState = createDescriptor({
  key: 'merchantAddressState',
  defaultValue: '',
  storages: STORAGE_LOCAL_AND_SESSION,
});

export const merchantNameState = createDescriptor({
  key: 'merchantNameState',
  defaultValue: '',
  storages: STORAGE_LOCAL_AND_SESSION,
});

export const nameState = createDescriptor({
  key: 'nameState',
  defaultValue: '',
  storages: STORAGE_LOCAL_AND_SESSION,
});

export const phoneState = createDescriptor({
  key: 'phoneState',
  defaultValue: '',
  storages: STORAGE_LOCAL_AND_SESSION,
});

export const emailState = createDescriptor({
  key: 'emailState',
  defaultValue: '',
  storages: STORAGE_LOCAL_AND_SESSION,
});

export const amountState = createDescriptor({
  key: 'amountState',
  defaultValue: '',
  storages: STORAGE_LOCAL_AND_SESSION,
});

export const accessTokenState = createDescriptor({
  key: 'accessTokenState',
  defaultValue: '',
  storages: STORAGE_LOCAL_AND_SESSION,
});

export const loginOtpVerifyCount = createDescriptor({
  key: 'loginOtpVerifyCount',
  defaultValue: 0,
  storages: STORAGE_SESSION_ONLY,
});

export const loginOtpVerifyDate = createDescriptor({
  key: 'loginOtpVerifyDate',
  defaultValue: '',
  storages: STORAGE_SESSION_ONLY,
  deserialize: (value) => {
    if (!value) {
      return value;
    }
    const parsed = typeof value === 'string' ? value : '';
    return parsed ? new Date(parsed) : parsed;
  },
});

export const themePreferenceState = createDescriptor({
  key: 'themePreferenceState',
  defaultValue: 'light',
  storages: STORAGE_LOCAL_AND_SESSION,
});
